<script>
import service from '@/service';
import * as Ladda from 'ladda';
import _ from 'lodash';
const LON_PH_TEXT = 'Izberi ali povleci LON Excel datoteko za uvoz ...';
const SKB_PH_TEXT = 'Izberi ali povleci SKB Xml datoteko za uvoz ...';
const VASCO_PH_TEXT = 'Izberi ali povleci Vasco Excel datoteko za uvoz ...';
const TRAFIC_PH_TEXT = 'Izberi ali povleci Trafic Excel datoteko za uvoz ...';

export default {
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			this.showError(null);
			let loader = Ladda.create(this.$refs.aOk);
			loader.start();
			if (this.show_step_two) {
				service.priliviSave(this.import_table.items)
					.then(response => {
						loader.stop();
						if (response.processed) {
							// next
							this.clearForm();
							this.$refs.modal.hide();
							this.$emit('priliviPotrjeni-success');
						} else {
							this.showError('Prilivov ni mogoče shraniti!');
						}
					})
					.catch(error => {
						loader.stop();
						this.showError('Napaka pri shranjevanju prilivov!');
						if (error) {
							console.log(error);
						}
					});
			} else {
				service.priliviUpload(this.tip_priliva, this.import_text, this.import_file)
					.then(response => {
						loader.stop();
						if (response.items && response.items.length > 0) {
							// next
							this.import_table.items = response.items;
							this.show_step_two = true;
						} else {
							this.showError('Prilivov ni mogoče uvoziti!');
						}
					})
					.catch(error => {
						loader.stop();
						this.showError('Napaka pri uvozu prilivov!');
						if (error) {
							console.log(error);
						}
					});
			}
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.show_step_two = false;
			this.tip_priliva = 'lon';
			this.import_file = null;
			this.import_text = '';
			this.message = {
				type: null,
				text: null
			};
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					loading(false);
					vm.ogrodja_options = vozila;
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		voziloSelect_change: function (value, index) {
			this.import_table.items[index].id_vozila = value.id;
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		toggleSelectAll: function () {
			for (let priliv of this.import_table.items) {
				priliv.selected = !this.selectAll;
			}
		}
	},
	watch: {
		tip_priliva: function () {
			this.import_file = null;
			this.import_text = '';
			this.showError(null);
		}
	},
	data: function () {
		return {
			show_step_two: false,
			tip_priliva: 'lon',
			import_file: null,
			import_text: '',
			import_table: {
				items: [],
				fields: [
					{ key: 'selected', sortable: false, class: 'tdPrilivSelect' },
					{ key: 'datum', label: 'Datum', sortable: false, class: 'tdPrilivDatum' },
					{ key: 'iskalniNiz', label: 'Naziv', sortable: false },
					{ key: 'ogrodje', label: 'Ogrodje', sortable: false, class: 'tdPrilivOgrodje' },
					{ key: 'znesek', label: 'Znesek', sortable: false, class: 'tdPrilivZnesek' }
				]
			},
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR',
			selectAll: true
		}
	},
	computed: {
		upload_placeholder () {
			if (this.tip_priliva === 'lon') {
				return LON_PH_TEXT;
			} else if (this.tip_priliva === 'vasco') {
				return VASCO_PH_TEXT;
			} else if (this.tip_priliva === 'trafic') {
				return TRAFIC_PH_TEXT;
			}
			return SKB_PH_TEXT;
		},
		upload_accept () {
			if (this.tip_priliva === 'lon') {
				return '.csv, .xls';
			} else if (this.tip_priliva === 'vasco') {
				return '.xls';
			} else if (this.tip_priliva === 'trafic') {
				return '.csv';
			}
			return '.xml';
		},
		ok_text () {
			if (this.show_step_two) {
				return 'Potrdi';
			}
			return 'Naprej';
		},
		modal_size () {
			if (this.show_step_two) {
				return 'lg';
			}
			return 'lg';
		},
		modal_body_class () {
			if (this.show_step_two) {
				return 'no_padding';
			}
			return '';
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Uvoz prilivov" class="modal-primary" :body-class="modal_body_class" :size="modal_size">
		<div v-if="!show_step_two">
			<b-row>
				<b-col>
					<b-form-group>
						<b-form-radio-group v-model="tip_priliva">
							<b-form-radio value="lon">LON (CSV, Excel)</b-form-radio>
							<b-form-radio value="vasco">Vasco (Excel)</b-form-radio>
							<b-form-radio value="skb">SKB (Xml)</b-form-radio>
							<b-form-radio value="trafic">TRAFIC (CSV)</b-form-radio>
							<b-form-radio value="izvoz">Izvoz (Email)</b-form-radio>
						</b-form-radio-group>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-file v-if="tip_priliva == 'lon' || tip_priliva == 'skb' || tip_priliva == 'vasco'|| tip_priliva == 'trafic'"
						v-model="import_file"
						:placeholder="upload_placeholder"
						drop-placeholder="Povleci datoteko za uvoz ..."
						:accept="upload_accept"></b-form-file>
					<b-form-textarea v-if="tip_priliva == 'izvoz'"
						v-model="import_text"
						placeholder="Vnesi besedilo za uvoz ..."
						rows="6"
						max-rows="9"></b-form-textarea>
				</b-col>
			</b-row>
		</div>
		<div v-else>
			<b-table
				responsive="sm"
				show-empty
				hover
				empty-text="Ni vnosov"
				table-class="no_padding"
				:items="import_table.items"
				:fields="import_table.fields">
				<template slot="HEAD_selected">
					 <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
				</template>
				<template slot="selected" slot-scope="data">
					 <b-form-checkbox v-model="data.item.selected"></b-form-checkbox>
				</template>
				<template slot="ogrodje" slot-scope="data">
					<v-select v-if="data.item.id_vozila == null" v-model="data.item.ogrodje" class="noVIN"
							:options="ogrodja_options"
							:taggable="true"
							:filterable="false"
							label="ogrodje"
							@input="voziloSelect_change($event,data.item.index)"
							@search="vozilaSelect_search"
							placeholder="Izberi vozilo ...">
							<template slot="no-options">Vnesite VIN številko vozila</template>
					</v-select>
					<v-select v-else v-model="data.item.ogrodje"
							:options="ogrodja_options"
							:taggable="true"
							:filterable="false"
							label="ogrodje"
							@input="voziloSelect_change($event,data.item.index)"
							@search="vozilaSelect_search"
							placeholder="Izberi vozilo ...">
							<template slot="no-options">Vnesite VIN številko vozila</template>
					</v-select>
				</template>
				<template slot="znesek" slot-scope="data">
					<span> {{ data.item.znesek | hr_money }}</span>
				</template>
				<template slot="datum" slot-scope="data">
					<div> {{ data.item.datum | hr_date }} </div>
				</template>
			</b-table>
		</div>
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="start">
						<b-button v-if="false" variant="warning" @click.stop="click_showPlacila($event.target)">Plačilo</b-button>
					</b-col>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click="modal_cancelClick($event)">Prekliči</b-button>
						<b-button ref="aOk" variant="primary" data-style="zoom-in" @click.stop="modal_okClick($event)">
							<span class="ladda-label">{{ ok_text }}</span>
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.ma_pos {
	text-align: end;
}
.noVIN {
	background-color: tomato;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message_b {
	margin: 1rem;
}
</style>
<style>
.no_padding {
	padding: 0;
	margin: 0;
}
.tdPrilivSelect {
	width: 50px;
}
.tdPrilivDatum {
	width: 110px;
}
.tdPrilivOgrodje {
	width: 250px;
}
.tdPrilivZnesek {
	width: 110px;
	text-align: right;
}
.custom-file-input ~ .custom-file-label::after {
	content: 'Izberi';
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/UvoziPrilivModal.vue